jQuery(document).ready(function () {
    jQuery(".left-menu-list .left-menu-items").hover(function () {
        // Remove active class from all left and right menu items
        jQuery(".left-menu-list .left-menu-items, .right-menu-list .right-menu-items").removeClass("active");

        // Add active class to the hovered left menu item
        jQuery(this).addClass("active");

        // Get the index of the hovered left menu item
        var index = jQuery(this).index();

        // Add offset of 4 to the index for the right menu items
        var rightMenuIndex = index + 4;

        // Add active class to the corresponding right menu item
        jQuery(".right-menu-list .right-menu-items").eq(rightMenuIndex).addClass("active");
    });
});


// ======== Product Details Page ("I’m buying this as a gift") ========

document.addEventListener("DOMContentLoaded", function () {
    const formContainer = document.createElement('div'); // Container for dynamic content
    formContainer.id = 'giftForm';

    // The form structure to be dynamically added
    const formHTML = `
        <div class="form-wrapper">
          <input type="text" required placeholder="Sender's Name*" name="properties[Sender's Name]">
          <input type="text" required placeholder="Recipient's Full Name*" name="properties[Recipient's Full Name]">
          <input type="text" required placeholder="Recipient’s Phone Number*" name="properties[Recipient’s Phone Number]">
          <textarea required placeholder="Recipient’s Address*" name="properties[Recipient’s Address]"></textarea>
          <textarea required placeholder="Gift Message*" name="properties[Gift Message]"></textarea>
      </div>
    `;

    // Event listener for dynamically loaded content
    document.body.addEventListener('change', function (e) {
        const giftCheckbox = e.target.closest('.send-as-gift input[type="checkbox"]');

        if (giftCheckbox) {
            if (giftCheckbox.checked) {
                formContainer.innerHTML = formHTML; // Add the form content
                giftCheckbox.parentNode.insertAdjacentElement('afterend', formContainer); // Insert form after the checkbox container

                // Add ZIP Code validation listener after the form is inserted
                const zipCodeInput = document.getElementById('zipCode');
                const deliveryMessage = document.getElementById('deliveryMessage');
                const addToCartButton = document.querySelector('.product-form__submit'); // Select your "Add to Cart" button (adjust selector as needed)

                if (zipCodeInput) {
                    zipCodeInput.addEventListener('input', function () {
                        const zipCode = this.value;
                        const validZipCodes = ['07024', '07660', '07604', '07605', '07643', '07074', '07075', '07077', '07074', '07014', '07070', '07071', '07073', '07072', '07010', '07020', '07022', '070710', '070109', '07031', '07047', '07109', '07104', '07032', '07094', '07093', '07086', '07087', '07307', '07030', '07306', '07029', '07102', '11370', '11105', '11356', '11371', '11369', '11103', '11106', '11101', '11104', '11372', '11377', '11378', '11379', '11374', '11102', '11369', '111368', '11374', '11371', '11357', '11354', '11355', '11367', '11375', '11385', '11222', '11211', '11205', '11201', '11231', '11212', '11217', '11225', '11238', '11206', '11237', '11221', '11233', '11213', '11216', '11232', '11218', '11226', '11203', '11212', '11220', '11219', '11204', '11230', '11210'];
                        if (!validZipCodes.includes(zipCode)) {
                            deliveryMessage.innerHTML = 'We are sorry, this product is not available for delivery in the requested area.';
                            deliveryMessage.style.display = 'block';
                            if (addToCartButton) {
                                addToCartButton.disabled = true; // Disable the "Add to Cart" button
                            }
                        } else {
                            deliveryMessage.style.display = 'none';
                            if (addToCartButton) {
                                addToCartButton.disabled = false; // Enable the "Add to Cart" button
                            }
                        }
                    });
                }

                // Check Delivery Date Based on Time
                const currentTime = new Date();
                const cutoffTime = new Date();
                cutoffTime.setHours(12, 0, 0, 0); // 12 PM EST Cutoff

                const deliveryDateInput = document.getElementById('deliveryDate');
                if (deliveryDateInput) {
                    deliveryDateInput.addEventListener('change', function () {
                        const deliveryDate = new Date(this.value);
                        if (currentTime > cutoffTime && deliveryDate.toISOString().split('T')[0] === currentTime.toISOString().split('T')[0]) {
                            alert('Order placed after 12 PM will be delivered the next day.');
                        }
                    });
                }

            } else {
                formContainer.remove();
            }
        }
    });
});

document.addEventListener("input", function (event) {
    const target = event.target;

    if (target && target.id === 'zipCode') {
        const zipCodeInput = target;
        const deliveryMessage = document.getElementById('deliveryMessage');
        const addToCartButton = document.querySelector('.product-form__submit'); // Adjust selector as needed

        const zipCode = zipCodeInput.value;
        const validZipCodes = [
            '07024', '07660', '07604', '07605', '07643', '07074', '07075', '07077', 
            '07074', '07014', '07070', '07071', '07073', '07072', '07010', '07020', 
            '07022', '070710', '070109', '07031', '07047', '07109', '07104', '07032', 
            '07094', '07093', '07086', '07087', '07307', '07030', '07306', '07029', 
            '07102', '11370', '11105', '11356', '11371', '11369', '11103', '11106', 
            '11101', '11104', '11372', '11377', '11378', '11379', '11374', '11102', 
            '11369', '111368', '11374', '11371', '11357', '11354', '11355', '11367', 
            '11375', '11385', '11222', '11211', '11205', '11201', '11231', '11212', 
            '11217', '11225', '11238', '11206', '11237', '11221', '11233', '11213', 
            '11216', '11232', '11218', '11226', '11203', '11212', '11220', '11219', 
            '11204', '11230', '11210','10034', '10040', '10033', '10032', '10039',
            '10031', '10030', '10037', '10027', '10026', '10035', '10025', '10029',
            '10000', '10128', '10024', '10028', '10075', '10021', '10065', '10044',
            '10022', '10017', '10016', '10020', '10023', '10019', '10036', '10018',
            '10001', '10010', '10011', '10003', '10009', '10014', '10012', '10002',
            '10013', '10282', '10007', '10038', '10009', '10006', '10005', '10280', '10004'];

        if (!validZipCodes.includes(zipCode)) {
            deliveryMessage.innerHTML = 'We are sorry, this product is not available for delivery in the requested area.';
            deliveryMessage.style.display = 'block';
            if (addToCartButton) {
                addToCartButton.disabled = true;
            }
        } else {
            deliveryMessage.style.display = 'none';
            if (addToCartButton) {
                addToCartButton.disabled = false;
            }
        }
    }
});

document.addEventListener("input", function (event) {
    const deliveryDateInput = document.getElementById('deliveryDate');

    if (deliveryDateInput) {
        // Set the min attribute to today's date
        const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
        deliveryDateInput.setAttribute('min', today);

        deliveryDateInput.addEventListener('change', function () {
            const currentTime = new Date();
            const cutoffTime = new Date();
            cutoffTime.setHours(12, 0, 0, 0); // 12 PM EST Cutoff

            const deliveryDate = new Date(this.value);
            if (currentTime > cutoffTime && deliveryDate.toISOString().split('T')[0] === currentTime.toISOString().split('T')[0]) {
                alert('Order placed after 12 PM will be delivered the next day.');
            }
        });
    }
});



